"use strict";
var $dyn;
(function ($dyn) {
    /**
     * Describes the groups for what is logged to the console.
     * @description Log groups enable exclusive logging
     * usage: add URL parameter such as &debug={"log":{"focus":true,"performance":true}} to see messages from just those groups.
     * using &debug=true will show messages from all logGroups
     */
    var logGroups;
    (function (logGroups) {
        logGroups["focus"] = "focus";
        logGroups["performance"] = "performance";
        logGroups["interactionThrottle"] = "interactionThrottle";
        logGroups["blockUserInteraction"] = "blockUserInteraction";
        logGroups["stopPropagation"] = "stopPropagation";
        logGroups["navigation"] = "navigation";
        logGroups["boot"] = "Logs events done at start up";
        logGroups["resources"] = "resources";
        logGroups["server"] = "Server form log";
        logGroups["list"] = "list";
        logGroups["reactList"] = "reactList";
        logGroups["framework"] = "framework";
        logGroups["preview"] = "preview";
        logGroups["async"] = "async";
        logGroups["form"] = "form";
        logGroups["shell"] = "shell";
        logGroups["popups"] = "popups";
        logGroups["skype"] = "skype";
    })(logGroups = $dyn.logGroups || ($dyn.logGroups = {}));
    $dyn.debug = {
        log: {},
    };
    /**
     * $dyn.debug is a set of runtime options that can be configured at runtime via the query string &debug.
     * @description $dyn.debugSettings represents the metadata for $dyn.debug.
     * This is similar to $dyn.flags except that flags should be used for options that would not appropriate to make available via the query string.
     * Conditional compile can be also used for feature not ready for consumption.
     */
    $dyn.debugSettings = {
        // It has key being the query string parameter and the value being the string description or an object with:
        // -category
        // -degradesPerf
        // -resources: A list of resource that should be loaded dynamically for the option. Resources are only loaded if the option is enabled.
        // -title
        bindingErrorAsMessages: {
            category: "Framework",
            title: "Outputs binding failures to the infolog",
        },
        combinedSearch: {
            category: "Experiments",
            title: "Enable the combined action/pages search.",
        },
        cortana: {
            category: "General",
            title: "Cortana",
        },
        develop: {
            resources: [
                "/Resources/Html/DeveloperTools.htm",
                /// #DEBUG
                "/Resources/Html/InternalDeveloperTools.htm",
            ],
            title: "Loads client developer tools",
        },
        domPerformance: {
            category: "Performance",
            title: "Enables the dynPerformance property on dom elements for performance analysis (degrades performance a medium amount)",
        },
        fieldHelp: {
            category: "General",
            title: "Show field level help icon",
        },
        findControl: {
            category: "Framework",
            degradesPerf: true,
            title: "Debugs the finding of controls",
        },
        general: {
            resources: [
                "/Resources/Html/DeveloperTools.htm",
                /// #DEBUG
                "/Resources/Html/InternalDeveloperTools.htm",
            ],
            title: "Also known as '&debug=true', starts debug mode which logs to the console and captures various debug information",
        },
        gridAppend: {
            category: "Experiments",
            title: "Appends (Inserts below existing) new rows in grid",
        },
        gridFastEdit: {
            category: "Experiments",
            title: "Enables fast grid row creation/edit",
        },
        latency: {
            category: "Performance",
            title: "Additional latency on all interaction calls to simulate a real environment",
        },
        layoutFlex: "Enable the flexbox layout for all browsers",
        layoutGrid: "Shows the layout grid to verify the UI conforms to grid unit",
        logOnlyActive: {
            title: "Logs only the active groups in the console",
        },
        noConfirmExit: "Leave without confirming exit",
        performance: {
            category: "Performance",
            title: "When doing an ETW performance capture this option should be enabled",
        },
        profile: {
            category: "Performance",
            title: "Enables profile captures (obsolete, use individual debug flags)",
        },
        profileInteractions: {
            category: "Performance",
            title: "Enables profiling interaction processing time (the server form processInteractions method)",
        },
        settings: {
            resources: [
                "/Resources/Html/DeveloperTools.htm",
                "/Resources/Html/InternalDeveloperTools.htm",
            ],
        },
        showErrors: {
            title: "Shows call stacks of errors in the error box",
        },
        staticLoaderOn: {
            category: "Experiments",
            title: "Enable static loader",
        },
        template: {
            category: "Framework",
            title: "Debug issues with loading templates",
        },
        traceParser: {
            category: "Performance",
            title: "Enables access to Trace Parser button in the Navigation Bar",
        },
        trackFormPerformance: {
            category: "Performance",
            title: "Track form render performance over time (uses local storage)",
        },
        typeAheadTimer: {
            category: "Performance",
            title: "Configures the timeout interval for type-ahead launched lookups",
        },
        useRTL: {
            category: "General",
            title: "Run the site in RTL mode",
        },
        verboseBinding: {
            category: "Framework",
            degradesPerf: true,
            title: "*Very* verbose, outputs the results of all binding handlers",
        },
        verboseForeach: {
            category: "Framework",
            degradesPerf: true,
            title: "Logs the timing for each interaction of the foreach",
        },
        verboseLayoutControlName: {
            category: "Framework",
            degradesPerf: true,
            title: "Add the control or form name to the arrange method",
        },
        verboseModels: {
            category: "Framework",
            degradesPerf: true,
            title: "Logs the models being used by bindings",
        },
        verboseStopPropagation: "Captures places where we stop event propagation",
    };
    $dyn.flagsSettings = {
        confirmExit: "Enables the confirm exit dialog",
        disableAnimations: "Disable animations.",
        disableCaptureRightClick: "Enables easier debugging by grid by allowing the inspect in the right click menu.",
        disableFocusReactions: "Disable reactions to focus",
        disableGlobalErrors: {
            title: "Uses the $dyn.error api to report unhandled exceptions.",
        },
        disableNPS: "Disables the NPS prompt",
        disablePing: "Disables pinging the server",
        disablePreview: "Disables previews",
        enableAutoClose: {
            title: "Auto close is currently causing problems in the control gallery, this flag disables auto close",
        },
        enableFocusTooltip: "Enable Tooltips on focus",
        enableResources: "Enables the &resource=x query string option to enable loading the initial form as a resource",
        fromVS: "Used by the &vs=true query string",
        popoutKeepOpen: "Keep popped out windows open when root navigation events happen",
        searchTraceLog: "Search local node trace log with browser activity IDs.",
        staticGenerators: "Should we use static values (normally used in tests)",
        updateURL: "Updates the browser url",
        useBrowserContextMenu: "Shows the normal browser context menu, instead of the custom menu",
        useHtmlImports: "Enables native resource loading using the html imports specification",
    };
    $dyn.flags = {
        confirmExit: false,
        disableAnimations: false,
        disableFocusReactions: true,
        disableGlobalErrors: false,
        disableNPS: false,
        disablePing: false,
        disablePreview: false,
        enableAutoClose: true,
        enableFocusTooltip: false,
        enableResources: true,
        fromVS: false,
        observableControlOptions: false,
        officeNavBar: false,
        popoutKeepOpen: false,
        searchTraceLog: true,
        staticGenerators: false,
        updateURL: false,
        useBrowserContextMenu: false,
        useDesignTimeView: false,
        useHtmlImports: false,
    };
    var resources;
    (function (resources) {
        resources.required = {};
    })(resources = $dyn.resources || ($dyn.resources = {}));
    var util;
    (function (util) {
        util.location = $dyn.util.parseUrl(window.location);
        util.location.query = $dyn.util.parseQueryString(window.location.search);
    })(util = $dyn.util || ($dyn.util = {}));
    if ($dyn.util.location.query.staticGenerators) {
        $dyn.flags.staticGenerators = true;
    }
    // check for popout url, restricted nav or embedded
    if ($dyn.util.location.query.popout) {
        $dyn.popout = true;
    }
    if ($dyn.util.location.query.embedded === "true") {
        $dyn.isEmbedded = true;
    }
    if ($dyn.util.location.query.limitednav || $dyn.popout || $dyn.isEmbedded) {
        $dyn.restrictedNavigation = true;
    }
    $(document).on("updateUtilLocationQuery", function () {
        var queryString = window.location.search;
        var qmarkPos = queryString.indexOf("?") + 1;
        queryString = queryString.substring(qmarkPos);
        if ($dyn.util.location.queryString !== queryString) {
            $dyn.util.location.queryString = queryString;
            $dyn.util.location.query = $dyn.util.parseQueryString(queryString);
        }
    });
    // The debug setting can be set via the query string - for example: &debug=true or &debug=binding or &debug=binding,template
    (function () {
        var queryDebug = $dyn.util.location.query.debug;
        try {
            // dynEnableSavedSettings can be set in the startup page.
            if (window.dynEnableSavedSettings && window.localStorage) {
                var serializedDebugSettings = localStorage.getItem("$dyn.debug");
                if (serializedDebugSettings) {
                    $dyn.debug = JSON.parse(serializedDebugSettings);
                }
                var serializedFlagSettings = localStorage.getItem("$dyn.flags");
                if (serializedFlagSettings) {
                    $dyn.flags = JSON.parse(serializedFlagSettings);
                }
            }
        }
        catch (error) {
            // IE 10 can give errors with access denied when trying localStorage
            // Use console log because $dyn.log isn't defined yet
            console.log("Error using local storage for debug settings: %o", error);
        }
        if (queryDebug === "true") {
            // Default debugging settings
            $dyn.debug.general = true;
        }
        else if (queryDebug) {
            // Either parse as JSON or as comma separated flags depending on first character
            if (queryDebug.charAt(0) === "{") {
                var parsedDebug = JSON.parse(queryDebug);
                $.extend(true, $dyn.debug, parsedDebug);
            }
            else {
                queryDebug = queryDebug.split(",");
                for (var i = 0, len = queryDebug.length; i < len; i++) {
                    $dyn.debug[queryDebug[i]] = true;
                }
            }
        }
        if ($dyn.debug.vs === true) {
            $dyn.flags.fromVS = true;
            if ($dyn.debug.confirmExit === true) {
                $dyn.flags.confirmExit = true;
            }
            $dyn.debug.develop = true;
            $dyn.debug.showErrors = true;
        }
        if ($dyn.debug.general) {
            $dyn.debug.showErrors = true;
        }
        for (var key in $dyn.debug) {
            if ($dyn.debug[key]) {
                var setting = $dyn.debugSettings[key];
                if (setting) {
                    // If the debug key is enabled then check for resources
                    var settingResources = setting.resources;
                    if (settingResources) {
                        for (var i = 0, len = settingResources.length; i < len; i++) {
                            $dyn.resources.required[settingResources[i]] = true;
                        }
                    }
                }
            }
        }
    })();
    if ($dyn.debug.noConfirmExit) {
        $dyn.flags.confirmExit = false;
    }
    /**
     * Enabled or disables logging.  Default is that logging is enabled by $dyn.debug.general
     */
    function enableLogging(enabled) {
        // Return a function that can be used for logger. When the console not is opened then the operation is a no-op.
        if (window.console) {
            // Need to bind the log function regardless because IE is missing the apply method on it.
            var logger_1 = Function.prototype.bind.call(console.log, console);
            if (console.group) {
                // Is enabled even when general logging is turned off
                $dyn._log = logger_1;
            }
            else {
                // tslint:disable-next-line:only-arrow-functions
                $dyn._log = Object.assign(function () {
                    if (arguments.length > 0) {
                        arguments[0] = Array(Math.max($dyn._log.groupDepth, 0)).join("  >  ") + arguments[0];
                    }
                    logger_1.apply(console, arguments);
                }, {
                    groupDepth: 0,
                });
            }
        }
        else {
            $dyn._log = Object.assign(function () { }, { groupDepth: 0 });
        }
        if (enabled) {
            $dyn.log = $dyn._log;
        }
        else {
            $dyn.log = (function () { });
        }
        var onlyLogActiveGroups = $dyn.debug.logOnlyActive;
        // if they selected to only log active groups turn off the default log
        if (onlyLogActiveGroups) {
            $dyn.log = (function () { });
        }
        if ($dyn.debug.log) {
            // Set up log group methods
            for (var groupName in $dyn.logGroups) {
                // if they have selected to only log active groups only turn on the active groups
                if ((!onlyLogActiveGroups && enabled) || $dyn.debug.log[groupName]) {
                    $dyn.log[groupName] = $dyn._log;
                    if (window.console) {
                        $dyn.log[groupName].error = Function.prototype.bind.call(console.error, console);
                        $dyn.log[groupName].warn = Function.prototype.bind.call(console.warn, console);
                        $dyn.log[groupName].info = Function.prototype.bind.call(console.info, console);
                        $dyn.log[groupName].trace = Function.prototype.bind.call(console.trace, console);
                    }
                }
            }
        }
        // Return a function that can be used for console. When the console is not opened then the operation is a no-op.
        if (enabled && window.console) {
            $dyn.logWarning = Function.prototype.bind.call(console.warn, console);
        }
        else {
            $dyn.logWarning = function () { };
        }
        if (window.console) {
            $dyn.logError = Function.prototype.bind.call(console.error, console);
        }
        else {
            $dyn.logError = function () { };
        }
        if (window.console) {
            var logDep_1 = Function.prototype.bind.call(console.error, console);
            // tslint:disable-next-line:only-arrow-functions
            $dyn.logDeprecated = function () {
                logDep_1.apply(console, ["DEPRECATED: "].concat(Array.prototype.slice.call(arguments)));
            };
        }
        else {
            $dyn.logDeprecated = function () { };
        }
        if (enabled && window.console && window.console.time && window.console.timeEnd) {
            $dyn.time = Function.prototype.bind.call(console.time, console);
            $dyn.timeEnd = Function.prototype.bind.call(console.timeEnd, console);
        }
        else {
            $dyn.time = function () { };
            $dyn.timeEnd = function () { };
        }
        if (enabled && window.console && console.group) {
            $dyn._logGroup = Function.prototype.bind.call(console.group, console);
            $dyn._logGroupEnd = Function.prototype.bind.call(console.groupEnd, console);
        }
        else {
            // tslint:disable-next-line:only-arrow-functions
            $dyn._logGroup = function () {
                $dyn._log.groupDepth++;
                $dyn._log.apply(null, arguments);
            };
            $dyn._logGroupEnd = function () {
                $dyn._log.groupDepth--;
            };
        }
        if (enabled) {
            if (window.console && console.group) {
                $dyn.logGroup = Function.prototype.bind.call(console.group, console);
                $dyn.logGroupEnd = Function.prototype.bind.call(console.groupEnd, console);
                $dyn.supportsLogGroup = true;
            }
            else {
                // tslint:disable-next-line:only-arrow-functions
                $dyn.logGroup = function () {
                    $dyn.log.groupDepth++;
                    $dyn.log.apply(null, arguments);
                };
                $dyn.logGroupEnd = function () {
                    $dyn.log.groupDepth--;
                };
            }
        }
        if (!$dyn.logGroup) {
            $dyn.logGroup = $dyn.logGroupEnd = function () { };
        }
    }
    $dyn.enableLogging = enableLogging;
    $dyn.enableLogging($dyn.debug.general);
    function saveSettings() {
        try {
            if (window.localStorage) {
                delete $dyn.debug.settings; // settings is option to load the settings form (also not shown on settings screen itself)
                localStorage.setItem("$dyn.debug", JSON.stringify($dyn.debug));
                localStorage.setItem("$dyn.flags", JSON.stringify($dyn.flags));
            }
        }
        catch (e) {
            if (e.name === "QuotaExceededError" ||
                e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                $dyn.logError("Binding Debug: local storage space quota error");
            }
            else {
                $dyn.logError("Binding Debug: local storage error: %s", e.name);
            }
        }
    }
    $dyn.saveSettings = saveSettings;
    function resetSettings() {
        try {
            if (window.localStorage) {
                localStorage.removeItem("$dyn.debug");
                localStorage.removeItem("$dyn.flags");
            }
            // tslint:disable-next-line:no-empty
        }
        catch (e) { }
    }
    $dyn.resetSettings = resetSettings;
})($dyn || ($dyn = {}));

//# sourceMappingURL=FlagSettings.js.map
